export default "__VITE_ASSET__jbgp9S0f__"